<template>
  <div class="pub-list-subsection" data-model-id="pub:list">
    <div class="list" v-if="itemsComputed.length">
      <button class="item" type="button" v-for="(it, idx) in itemsComputed" :key="it.id || idx" v-anim="'animate__fadeInUp'" :style="{animationDelay: (0.1 + idx*0.1) + 's'}" @click="$emit('select', it)">
        <div class="item-left">
          <div class="meta-row">
            <span class="featured">置顶公告</span>
            <time class="date">{{ it.date }}</time>
          </div>
          <div class="pub-title">{{ it.title }}</div>
          <div class="desc">{{ it.desc }}</div>
          <div class="highlights" v-if="it.highlights && it.highlights.length">
            <div class="highlight" v-for="highlight in it.highlights" :key="highlight.label">
              <strong>{{ highlight.value }}</strong>
              <span>{{ highlight.label }}</span>
            </div>
          </div>
        </div>
        <div
          class="item-right"
          :class="{ 'has-posters': it.images && it.images.length }"
          :style="it.images && it.images.length ? null : { backgroundImage: `url(${it.imageSrc || '/static/img/pub-image-3@2x.png'})` }"
        >
          <template v-if="it.images && it.images.length">
            <div class="poster-preview" v-for="(image, imageIndex) in it.images" :key="image">
              <img :src="image" :alt="it.title + '配图' + (imageIndex + 1)" />
            </div>
          </template>
          <div class="view-detail">查看完整喜报 <span aria-hidden="true">→</span></div>
        </div>
      </button>
    </div>
    <div class="empty" v-else>
      <div class="empty-title">暂无公告</div>
      <div class="empty-desc">请稍后再查看最新内容</div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "PubListSubsection",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    itemsComputed() { return Array.isArray(this.items) ? this.items : []; },
  },
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : "animate__fadeInUp";
        el.classList.add("animate__animated");
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                el.classList.add(cls);
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(el);
      },
    },
  },
};
</script>

<style scoped>
.pub-list-subsection { position: absolute; left: 160px; top: 907px; width: 1560px; }
.list { display: flex; flex-direction: column; }
.item {
  align-items: stretch;
  appearance: none;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(0, 24, 60, 0.08);
  box-shadow: 0 22px 70px rgba(0, 24, 60, 0.09);
  color: inherit;
  cursor: pointer;
  display: flex;
  gap: 70px;
  justify-content: space-between;
  margin: 0 0 40px;
  min-height: 360px;
  overflow: hidden;
  padding: 42px 46px 42px 56px;
  position: relative;
  text-align: left;
  transition: box-shadow 180ms ease, transform 180ms ease;
  width: 100%;
}
.item::before {
  background: linear-gradient(180deg, #b80f18 0%, #ef4c22 100%);
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  top: 0;
  width: 6px;
}
.item:hover { box-shadow: 0 28px 86px rgba(0, 24, 60, 0.14); transform: translateY(-3px); }
.item:hover .pub-title { color: #0a66bd; }
.item:focus-visible { outline: 3px solid rgba(3, 146, 221, 0.45); outline-offset: 4px; }
.item-left { display: flex; flex: 1; flex-direction: column; min-width: 0; padding-top: 4px; }
.meta-row { align-items: center; display: flex; gap: 16px; }
.featured {
  background: #fff0ec;
  border: 1px solid #ffd6cc;
  border-radius: 17px;
  color: #c93b20;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 14px;
  line-height: 30px;
  padding: 0 16px;
}
.date { color: #66758a; font-family: "Poppins", Helvetica; font-size: 15px; line-height: 30px; }
.pub-title { color: #00183c; display: block; font-family: "PingFang SC-Semibold", Helvetica; font-size: 32px; font-weight: 600; line-height: 44px; margin-top: 24px; transition: color 160ms ease; }
.desc { color: #344963; display: block; font-family: "PingFang SC-Regular", Helvetica; font-size: 17px; font-weight: 400; line-height: 31px; margin-top: 18px; max-width: 850px; }
.highlights { display: flex; gap: 42px; margin-top: auto; padding-top: 24px; }
.highlight { align-items: baseline; display: flex; gap: 9px; }
.highlight strong { color: #c83b21; font-family: "Poppins", Helvetica; font-size: 25px; font-weight: 600; line-height: 34px; }
.highlight span { color: #69768a; font-family: "PingFang SC-Regular", Helvetica; font-size: 14px; line-height: 24px; }
.item-right { background-position: 50% 50%; background-size: cover; flex: 0 0 455px; height: 274px; position: relative; }
.item-right.has-posters { background: #990b13; display: grid; gap: 3px; grid-template-columns: repeat(3, 1fr); overflow: hidden; }
.poster-preview { height: 100%; overflow: hidden; position: relative; }
.poster-preview img { height: 100%; object-fit: cover; object-position: top center; transition: transform 240ms ease; width: 100%; }
.item:hover .poster-preview img { transform: scale(1.025); }
.view-detail {
  align-items: center;
  background: linear-gradient(90deg, rgba(107, 0, 7, 0.92), rgba(180, 15, 24, 0.88));
  bottom: 0;
  color: #ffffff;
  display: flex;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 15px;
  height: 46px;
  justify-content: center;
  left: 0;
  letter-spacing: 0.5px;
  position: absolute;
  right: 0;
}
.view-detail span { font-family: Helvetica; font-size: 22px; margin-left: 12px; transition: transform 180ms ease; }
.item:hover .view-detail span { transform: translateX(5px); }
.empty { align-items: center; background: rgba(255, 255, 255, 0.72); border: 1px solid rgba(0, 24, 60, 0.08); display: flex; flex-direction: column; height: 220px; justify-content: center; }
.empty-title { color: #00183c; font-family: "PingFang SC-Medium", Helvetica; font-size: 28px; line-height: 40px; }
.empty-desc { color: #59708f; font-family: "PingFang SC-Regular", Helvetica; font-size: 18px; line-height: 30px; margin-top: 8px; }
</style>
